import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[kui-menu-actions]',
})
export class KuiMenuActionsDirective {
    @HostBinding('class.menu-actions') menuActionsClass = true;
}
